<template>
  <div>
    <v-navigation-drawer v-model="drawer" app color="blue darken-3" dark clipped :mini-variant.sync="mini">
      <v-list dense>
        <template v-for="nav_list in nav_lists">
          <v-list-group
            v-if="nav_list.lists && nav_list.lists.length > 0"
            link
            :key="nav_list.name"
            :prepend-icon="nav_list.icon"
            no-action
            :append-icon="nav_list.lists ? undefined : ''"
            :class="nav_list.style"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              link
              v-for="list in nav_list.lists"
              :key="list.name"
              :to="list.link"
              @click.stop="mini = !mini"
              :class="list.style"
            >
              <v-list-item-content>
                <v-list-item-title>{{ list.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else
            link
            :key="nav_list.id"
            :to="nav_list.link"
            @click.stop="mini = true"
            :class="nav_list.style"
          >
            <v-list-item-action>
              <v-icon>{{ nav_list.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      :clipped-right="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon
        @click.stop="
          drawer = !drawer;
          mini = !mini;
        "
      />
      <v-toolbar-title class="hidden-xs-only">LIPSAS Neo</v-toolbar-title>
      <v-spacer />

      <v-text-field
        ref="condition"
        v-model="headerSearchCondition"
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="顧客氏名カナ or 証券番号 or 電話番号（ハイフンなし）"
        clearable
        clear-icon="mdi-close-circle"
        :append-outer-icon="headerSearchCondition ? 'mdi-send' : ''"
        @click:append-outer="searchCustomer"
        @click:clear="clearInput"
        @keypress.enter="searchCustomer"
      ></v-text-field>

      <v-spacer />

      <v-toolbar-title class="hidden-xs-only">0120-347-082</v-toolbar-title>

      <v-badge :content="notReadCount" :value="notReadCount" color="red" offset-x="25" offset-y="25" overlap>
        <v-btn icon @click.stop="noticeDrawer = !noticeDrawer">
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </v-badge>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <div v-on="on" class="profile">
            <span>{{ user.profileInitials }}</span>
          </div>
        </template>
        <v-list>
          <v-list-item link @click="changePassword">
            <v-list-item-content>
              <v-list-item-title>パスワード変更</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="setup">
            <v-list-item-content>
              <v-list-item-title>2段階認証設定</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="hasMessageAddPermission" link @click="addMeaasge">
            <v-list-item-content>
              <v-list-item-title>お知らせ登録</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="logout">
            <v-list-item-content>
              <v-list-item-title>ログアウト</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="noticeDrawer" :disable-resize-watcher="true" app clipped right width="350px">
      <v-container>
        <v-list v-for="card in noticeList" :key="card.id">
          <v-card>
            <v-card-title> {{ card.title }}</v-card-title>
            <v-card-subtitle>
              {{ card.register }} &nbsp;
              {{ card.registerDate }}
            </v-card-subtitle>
            <v-card-text style="white-space: pre-line">
              {{ card.message }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="hasMessageUpdatePermission && card.kind == 1"
                color="primary"
                class="px-4"
                elevation="2"
                text
                @click="editMeaasge(card)"
              >
                編集
              </v-btn>
              <v-btn
                v-if="card.kind == 2"
                color="primary"
                class="px-4"
                elevation="2"
                text
                @click="gotoDailyReport(card)"
              >
                日報へ
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="!card.alreadyRead" color="primary" class="px-4" elevation="2" @click="readNotice(card)">
                既読
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-list>
      </v-container>
    </v-navigation-drawer>

    <SetupDevice ref="SetupDevice" />
    <PasswordChange ref="PasswordChange" />
    <MessageEdit ref="MessageEdit" @messageEdited="messageEdited" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import SetupDevice from "@/components/SetupDevice.vue";
import PasswordChange from "@/components/PasswordChange.vue";
import MessageEdit from "@/components/MessageEdit.vue";

export default {
  name: "Menu",
  data: () => ({
    darkmode: false,
    drawer: null,
    mini: true,
    nav_lists: [],
    notReadCount: 0,
    noticeDrawer: false,
    noticeList: [],
    headerSearchCondition: ""
  }),
  computed: {
    ...mapState(["user", "menuList", "urlList"]),
    hasMessageAddPermission() {
      const messagePermission = this.urlList.find((element) => element === "/message/add");

      if (messagePermission != null) {
        return true;
      }
      return false;
    },
    hasMessageUpdatePermission() {
      const messagePermission = this.urlList.find((element) => element === "/message/update");

      if (messagePermission != null) {
        return true;
      }
      return false;
    }
  },
  components: { SetupDevice, PasswordChange, MessageEdit },
  methods: {
    ...mapActions(["setLoginStatus"]),
    loadMenu() {
      this.nav_lists = this.menuList;
    },
    async loadNotice() {
      this.notReadCount = 0;
      this.noticeList = await this.$api.getNotice();
      this.noticeList.forEach((card) => {
        if (!card.alreadyRead) {
          this.notReadCount++;
        }
      });
    },
    async searchCustomer() {
      if (this.headerSearchCondition.length == 0) {
        return;
      }
      //console.log(this.$router.currentRoute.path);
      if (this.$router.currentRoute.path == "/customerSearch") {
        await this.$router.replace({
          name: "dummy"
        });
      }

      this.$router.replace({
        name: "customerSearch",
        params: { headerSearchCondition: this.headerSearchCondition }
      });
      this.clearInput();
    },
    clearInput() {
      this.headerSearchCondition = "";
      this.$refs.condition.blur();
    },
    logout() {
      this.setLoginStatus(false);
      this.$api.logout().then((data) => {
        if (data && data.status == 200) {
          this.$router.replace("/");
        }
      });
    },
    setup() {
      this.$refs.SetupDevice.open();
    },
    changePassword() {
      this.$refs.PasswordChange.open();
    },
    gotoDailyReport(card) {
      this.notReadCount--;
      card.alreadyRead = true;
      this.noticeList.splice(this.noticeList.indexOf(card), 1);
      this.noticeDrawer = false;
      this.$router.push({
        name: "dailyReportEdit",
        params: { date: card.registerDate }
      });
    },
    async readNotice(card) {
      //console.log(card);
      await this.$api.readNotice(card);
      this.notReadCount--;
      card.alreadyRead = true;
      if (card.kind == 2) {
        this.noticeList.splice(this.noticeList.indexOf(card), 1);
      }
    },
    addMeaasge() {
      this.$refs.MessageEdit.open();
    },
    editMeaasge(card) {
      this.$refs.MessageEdit.open(card);
    },
    async messageEdited() {
      this.loadNotice();
    }
  },
  created() {
    this.loadMenu();
  },
  mounted() {
    this.loadNotice();
    if (this.user.needToChangePassFlag) {
      this.changePassword();
    }
  }
};
</script>
<style lang="scss">
.profile {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-left: 10px;
  border-radius: 50%;
  font-size: 14px;
  color: #fff;
  background-color: #0c4fa7;

  span {
    pointer-events: none;
  }
}

.newline {
  white-space: pre-line;
}

.v-toolbar__title {
  cursor: pointer;
}
.v-list--dense .v-list-item .v-list-item__title {
  font-size: 14px;
}
/* 下記の書き方がscopedの場合効かない */
.v-list .v-list-item--active {
  color: white;
}

.hidden-on-small-device {
  @media (max-width: 900px) {
    display: none;
  }
}
</style>
